import { getParsedDate } from "../utils/util";

export function parseReportThemeChoices(data) {

  data.forEach(element => {   
    element["id"] = element["reportThemeId"]                       
    element["description"] = element['description'] ?? element['name'];
          
    delete element["reportThemeId"];
  });
  return data;
}

export function parseReportThemeTemplates(data) {

  data.forEach(element => {   
    element["id"] = element["reportThemeTemplateId"];
    element["name"] = element["displayName"]
    element["description"] = element['description'] ?? element['name'];

    delete element["displayName"];
    delete element["reportThemeTemplateId"];
    delete element["configuration"];
    delete element["version"];
    delete element["versionComment"];
    delete element["versionCreatedAt"];
    delete element["versionCreatedBy"];
  });
  return data;
}

export function infuseReportTypeIntoTemplates(templates, reportThemes) {
  return templates.map((template) => ({
    ...template,
    reportType: reportThemes.find((reportTheme) => reportTheme.id === template.reportThemeId)?.reportType,
  }));
}

export function parseCreateClientReportThemeTemplate(data) {

  delete data['customisation'];
  delete data['configuration'];    
  
  return JSON.stringify(data);
}

export function parseCreateClientReportTheme(data) {

  data['configuration'] = JSON.stringify(data.configurations);
  
  delete data['reportType'];
  delete data['configurations'];
  delete data['reportThemeTemplateId'];
  
  return JSON.stringify(data);
}

export function parseUpdateClientReportTheme(data) {

  data['configuration'] = JSON.stringify(data.configurations);
  data['versionComment'] = data['addVersionComment'];
  data['clientReportThemeId'] = data['id'];
  
  delete data['reportType'];
  delete data['version'];
  delete data['createdAt'];
  delete data['createdBy'];
  delete data['deletedAt'];
  delete data['id'];
  delete data['configurations'];
  delete data['addVersionComment'];
  
  return JSON.stringify(data);
}

export function parseReportThemeSchema(data){
  return data;
}

export function parseReportThemeShow(data){
  data['id'] = data['clientReportThemeId'] ?? `client/${data['clientId']}/template/${data['reportThemeTemplateId']}`;
  data['createdAt'] = getParsedDate(data['createdAt']);
  return data;
}

export function parseReportThemeShowDifferently(data, id){
  data['id'] = id;
  data['createdAt'] = getParsedDate(data['createdAt']);
  return data;
}